module.exports = "<message-dialog></message-dialog>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/notifier/notifier.component.html
// module id = ../../../../../app/shared/components/notifier/notifier.component.html
// module chunks = main